function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ListingBadge } from '@domain-group/fe-allhomes-library/lib/node';
import { MultiValueSearchQueryField } from '../multi-value-search-query-field';
import { parseSlugs } from '../../utils/parse-slugs';
export class BadgesFilter extends MultiValueSearchQueryField {
  constructor(searchOptions, values) {
    var defaultSelected = searchOptions.searchType === 'new-price' ? [ListingBadge.priceReduced.name] : [];
    super(searchOptions, Object.values(ListingBadge), [...defaultSelected, ...(values || [])], defaultSelected);
    _defineProperty(this, "urlSlug", BadgesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new BadgesFilter(searchOptions, parseSlugs(ListingBadge, q[BadgesFilter.urlSlug]));
  }
}
_defineProperty(BadgesFilter, "urlSlug", 'badges');